<div class="custom-header" (dblclick)="toggleGroup()">
  <!-- a11y (ESP-18584): native button so screen reader / voice control users can
       identify and operate the expand/collapse for BOTH the Plan rollup row and
       the MU group rows. It always renders (AG Grid's own toggle is hidden via
       CSS) so keyboard focus and behaviour are consistent across every group.
       aria-expanded exposes the current state and the accessible name updates
       dynamically with it (WCAG 2.1.1 / 4.1.2). -->
  <button type="button"
          class="ag-group-toggle"
          [class.ag-group-expanded]="isExpanded"
          [class.ag-group-contracted]="!isExpanded"
          [attr.aria-expanded]="isExpanded"
          [attr.aria-label]="isRollupHeader
              ? ((isExpanded ? 'multi.mu.rollup.group.collapse.aria' : 'multi.mu.rollup.group.expand.aria') | translate)
              : ((isExpanded ? 'multi.mu.group.collapse.aria' : 'multi.mu.group.expand.aria') | translate:{'0': groupDisplayName})"
          (keydown)="onToggleKeydown($event)"
          (click)="toggleGroup()">
    <span class="ag-icon" [ngClass]="isExpanded ? 'ag-icon-tree-open' : 'ag-icon-tree-closed'" aria-hidden="true">
    </span>
  </button>
  <span class="header-title" *ngIf="isRollupHeader===false">
    <span class="group-name" title="{{groupDisplayName}}">{{groupDisplayName}}</span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks>0 && showNhtpLink"><a id="training-period" href="#" (click)="this.showNhtpDialog($event)">{{this.newHireTrainingWeeks}} {{"multi.mu.group.nhtp"|translate}}</a></span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks==0 && showNhtpLink"><a id="training-period" href="#" (click)="this.showNhtpDialog($event)">{{"multi.mu.group.nhtp.no.value"|translate}}</a></span>
  </span>
  <span *ngIf="isRollupHeader" title='{{"multi.mu.rollup.group.header" | translate}}'>{{"multi.mu.rollup.group.header" | translate}}</span>
  <!-- Add any custom elements you want here -->
</div>
